import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
